var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "history-wrapper" }, [
    _c("div", { staticClass: "history-box flexBox" }, [
      _c("section", { staticClass: "history-chunk base-info-chunk flexBox" }, [
        _c("img", {
          staticClass: "avatar",
          attrs: { src: _vm.HeadImg },
          on: { error: _vm.$imgErr }
        }),
        _vm._v(" "),
        _c("h3", { staticClass: "base-info info-name" }, [
          _vm._v(_vm._s(_vm.infoName))
        ]),
        _vm._v(" "),
        _c("h3", { staticClass: "base-info department" }, [
          _vm._v(_vm._s(_vm.Department))
        ])
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "history-chunk mine-items-chunk flexItem" },
        [
          _c("ul", { staticClass: "mine-items" }, [
            _c(
              "li",
              {
                staticClass: "mine-item flexBox",
                on: {
                  click: function($event) {
                    return _vm.actionSeekHelp("Mine")
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "item-icon",
                  attrs: { src: "/static/images/icon/mine-seek.svg" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "item-name flexItem" }, [
                  _vm._v("我的服务请求")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "item-arrow" })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "mine-item flexBox",
                on: { click: _vm.viewAllDailyReport }
              },
              [
                _c("img", {
                  staticClass: "item-icon",
                  attrs: { src: "/static/images/icon/history-report.svg" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "item-name flexItem" }, [
                  _vm._v("近期知识日报")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "item-arrow" })
              ]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-14f7c465", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-14f7c465","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/mine/mine.vue
// module id = null
// module chunks = 